export const ALIGN_PROPS = ['start', 'end', 'baseline', 'center', 'stretch', 'unset'];
export const COLUMN_TYPES = ['wrapper', 'content', 'spreads'];